"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _const = require("../../const");

var _style = require("./style");

var _svg = require("./svg");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ChartIcon = function ChartIcon(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? _const.TYPE_BAR : _ref$type,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$setData = _ref.setData,
      setData = _ref$setData === void 0 ? function (data) {} : _ref$setData;
  return _react["default"].createElement(_style.StyledBox, null, _react["default"].createElement(_style.StyledIcon, {
    active: active,
    disabled: disabled,
    onClick: function onClick() {
      return setData({
        type: type
      });
    }
  }, type === _const.TYPE_BAR && _react["default"].createElement(_svg.Bar, null), type === _const.TYPE_STACKED_BAR && _react["default"].createElement(_svg.StackedBar, null), type === _const.TYPE_BAR_HORIZONTAL && _react["default"].createElement(_svg.BarHorizontal, null), type === _const.TYPE_STACKED_BAR_HORIZONTAL && _react["default"].createElement(_svg.StackedBarHorizontal, null), type === _const.TYPE_PIE && _react["default"].createElement(_svg.Pie, null), type === _const.TYPE_DONUT && _react["default"].createElement(_svg.Donut, null), type === _const.TYPE_LINE && _react["default"].createElement(_svg.Line, null), type === _const.TYPE_SCATTERPLOT && _react["default"].createElement(_svg.Scatterplot, null), type === _const.TYPE_MAP && _react["default"].createElement(_svg.MapIcon, null)));
};

var _default = ChartIcon;
exports["default"] = _default;